import { getLayer, isStatsigInitialized } from '@eventbrite/statsig';
import React from 'react';
import { LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT } from '../../constants';
import {
    DescriptiveOrganizerInfo,
    DescriptiveOrganizerInfoProps,
} from '../_shared/OrganizerInfo/DescriptiveOrganizerInfo';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
    captchaKey,
    eventId,
    eventName,
    gaCategory,
    isAuthenticated,
    organizerAvatar,
    organizerDescription,
    organizerId,
    organizerName,
    organizerUrl,
    organizerFacebook,
    organizerTwitter,
    organizerWebsite,
}: OrganizerPanelLayoutProps & DescriptiveOrganizerInfoProps) => {
    if (!isStatsigInitialized()) {
        return null;
    }

    const organizerPanelExperimentValue = getLayer(
        LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT.layer,
        LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT.param,
        LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT.defaultValue,
    );

    const isOldOrganizerPanelControlVariant =
        organizerPanelExperimentValue ===
        LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT.defaultValue;

    return (
        <section className="listing-organizer eds-l-pad-bot-5">
            {isOldOrganizerPanelControlVariant ? (
                <>
                    <hr className="eds-l-mar-top-2" />
                    <div
                        id="listings-root__organizer-panel"
                        className="organizer-panel"
                    ></div>
                    <hr className="eds-l-mar-top-2" />
                </>
            ) : (
                <DescriptiveOrganizerInfo
                    captchaKey={captchaKey}
                    organizerAvatar={organizerAvatar}
                    organizerDescription={organizerDescription}
                    organizerId={organizerId}
                    organizerName={organizerName}
                    organizerUrl={organizerUrl}
                    organizerFacebook={organizerFacebook}
                    organizerTwitter={organizerTwitter}
                    organizerWebsite={organizerWebsite}
                    isAuthenticated={isAuthenticated}
                    eventId={eventId}
                    eventName={eventName}
                    gaCategory={gaCategory}
                />
            )}
            {shouldShowMoreEventsFromThisOrganizer && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            <div id="listings-root__collections-related-to-this-event"></div>
        </section>
    );
};
